import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@ant-design/v5-patch-for-react-19'

import 'antd/dist/reset.css'
import '@fontsource-variable/inter'
import '~/assets/styles/tailwind.css'
import '~/styles/saudi-riyal-font.css'
import '~/styles/global-shell.css'

import { Providers } from '~/components/Providers'
import { App } from '~/App'

const container = document.getElementById('root')
if (!container) throw new Error('#root not found')

createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <Providers>
        <App />
      </Providers>
    </BrowserRouter>
  </React.StrictMode>
)
